





















































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import AgencyUserDto from '@/models/AgencyUsers/AgencyUserDto';
import UpdateAgencyUserGeneralDetailsRequest from '@/models/AgencyUsers/UpdateAgencyUserGeneralDetailsRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import BranchDto from '@/models/Branches/BranchDto';

@Component({
    name: 'AgencyUserEdit'
})
export default class extends GiganautVueDialog {
 
  public entity = new AgencyUserDto

  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = JSON.parse(JSON.stringify(AgencySettingsModule.currentAgencyUser));
      this.entity.emailAddress = this.entity.user.username;
      //Need to copy the default branch from the branch list if there is one
      //so that the desks are populated correctly 
      if (this.entity.defaultBranch) {
        this.entity.defaultBranch = this.branches.find((findBranch: BranchDto) => findBranch.id === this.entity.defaultBranch.id);
      } 
    }
  }

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }

  get desks() {
    if (this.entity.defaultBranch) {
      return this.entity.defaultBranch.desks;
    }
    return [];
  }

  get branches() {
      return AgencySettingsModule.branches;
  }

  get managerOptions() {
    return AgencySettingsModule.agencyUsers
      .filter((u: AgencyUserDto) => u.id !== this.entity.id)
      .map((u: AgencyUserDto) => ({ text: u.person.firstName + ' ' + u.person.lastName, value: u.id }));
  }

  @Watch('entity.defaultBranch')
  onDefaultBranchChanged(val: BranchDto, oldVal: BranchDto) {
    if (!val) {
      this.entity.defaultDeskId = undefined;
      this.entity.defaultDesk = undefined;
    }
  }

  async save() {
        if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new UpdateAgencyUserGeneralDetailsRequest();
    request.updatedAt = this.entity.updatedAt;
    request.firstName = this.entity.person.firstName;
    request.lastName = this.entity.person.lastName;
    request.mobilePhoneNumber = this.entity.mobilePhoneNumber;
    request.otherPhoneNumber = this.entity.otherPhoneNumber;
    if (this.entity.defaultBranch) {
      request.defaultBranchId = this.entity.defaultBranch.id;
    }
    if (this.entity.defaultDesk) {
      request.defaultDeskId = this.entity.defaultDesk.id;
    }
    request.isAdministrator = this.entity.isAdministrator;
    request.emailAddress = this.entity.emailAddress;
    request.managerId = this.entity.managerId;
    await AgencySettingsModule.editAgencyUserGeneralDetails(request)
    this.dialog = false;
  }
}
